import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Table, Spin, Space } from "antd";
import { getAllUsersData } from "store/adminPanel/actions";
import { Popover, Tooltip } from "@mui/material";
import { Checkbox } from "components";
import { ReactComponent as ActionsIcon } from '../../../../../assets/icons/more_dots.svg';
import ActionList from './components/ActionList';
import SearchComponent from './components/SearchComponent';
import { CreateModal, DeleteModal, ViewModal } from "components/layout/components";
import EditModal from "components/layout/components/editModal";
import TableCell from "./components/TableCell";
import AddKeyModal from "components/layout/components/addKeyModal";

const UsersConfig = () => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const dispatch = useDispatch();
    const users = useSelector((state => state.adminPanel.allUsers));
    const [displayedUsers, setDisplayedUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedUser,setSelectedUser] = useState("");
    const [open, setOpen] = useState(Boolean(anchorEl));
    const [createOpen, setCreateOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [viewOpen, setViewOpen] = useState(false);
    const [addKeyOpen, setAddKeyOpen] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * 10;
    const endIndex = startIndex + 10;
    const displayedItems = displayedUsers && displayedUsers.slice(startIndex, endIndex);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        dispatch(getAllUsersData());
    }, []);
    useEffect(()=>{
        if(users){
            setDisplayedUsers(users);
        }
    },[users])

    useEffect(() => {
        if(users){
            setLoading(false);
        }
    }, [users]);

    useEffect(()=>{
        if(editOpen || viewOpen || addKeyOpen){
            setOpen(false);
            setAnchorEl(null);
        }
    },[editOpen,viewOpen, addKeyOpen])

    const handlePageChange = page => {
        setCurrentPage(page);
        setChecked(false);
        setSelectedUsers([]);
      };
    const onMoreClick = (id) => (event) => {
        setSelectedUser(id);
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setAnchorEl(null);
    };
    const checkAll = () => {
        if(checked){
            setChecked(false);
            setSelectedUsers([]);
        }
        else{
            const uniqueValuesSet = new Set([
            ...selectedUsers,
            ...displayedItems.map(item=>item.id)
            ]);
            const uniqueValuesArray = Array.from(uniqueValuesSet);
            setSelectedUsers(uniqueValuesArray);
            setChecked(true);
        }
    }
    const handleCheck = (id) => {
        if(selectedUsers.includes(id)){
            const tempSelectedUsers = selectedUsers.filter(item => item != id);
            setSelectedUsers(tempSelectedUsers);
        } else {
            setSelectedUsers([...selectedUsers, id]);
        }
    }
      
    const columns = [
        {
            title: <Checkbox checked={checked} onChange={()=>checkAll()}></Checkbox>,
            dataIndex: 'id',
            render: (value) => {
                return <Checkbox checked={selectedUsers.includes(value)} onChange={()=>handleCheck(value)}></Checkbox>;
            }
        },
        {
            title: "User ID",
            dataIndex: 'id',
            key: 'id',
            render: text => {
                return <TableCell text={text} />;
            },
        },
        {
            title: "First Name",
            dataIndex: 'firstName',
            key: 'firstName',
            render: text => {
                return <TableCell text={text} />;
            },
        },
        {
            title: "Last Name",
            dataIndex: 'lastName',
            key: 'lastName',
            render: text => {
                return <TableCell text={text} />;
            },
        },
        {
            title: "Email",
            dataIndex: 'email',
            key: 'email',
            render: text => {
                return <TableCell text={text} />;
            },
        },
        {
            title: "",
            fixed: 'right',
            key: "action",
            align: "right",
            render: (text, record) => {
                return (
                    <Space align="end">
                        <Tooltip title="Actions">
                            <ActionsIcon aria-describedby={record.id} onClick={(e) => onMoreClick(record.id)(e)} style={{ cursor: "pointer"}} />
                        </Tooltip>
                    </Space>
                );
            },
        },
    ];

    return (
        loading ?
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "50px"
            }}
        >
            <Spin size="large" />
        </div>
        :
        <div id="users-config-page">
            <SearchComponent 
                displayedUsers={displayedUsers} 
                setDisplayedUsers={setDisplayedUsers} 
                allUsers={users} 
                setChecked={setChecked} 
                setSelectedUsers={setSelectedUsers} 
                setCurrentPage={setCurrentPage} 
                className='shrunk' 
            />
            <div style={{display:"flex", justifyContent:"right", alignItems:"right", marginTop:"5rem"}}>
                <Button className="config-create" type="default" onClick={()=>setCreateOpen(true)}>Create</Button>
                <Button style={{marginLeft:"1.438rem"}} className="config-delete" type="primary" onClick={()=>setDeleteOpen(true)}>Delete</Button>
            </div>
            <div style={{marginTop:"3rem"}}>
                <Table
                    scroll={{ x: true }}
                    className="results-table"
                    dataSource={displayedUsers}
                    columns={columns}
                    rowKey="id"
                    pagination={{ showSizeChanger: false, showTitle: false, onChange: handlePageChange }}
                />
            </div>
            <div>
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center', 
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    // style={{marginLeft:"160px"}}
                >
                    <ActionList open={()=>setOpen()} anchorEl={()=>setAnchorEl()} id={selectedUser} setEditOpen={setEditOpen} setViewOpen={setViewOpen} setAddKeyOpen={setAddKeyOpen}/>
                </Popover>
            </div>
            <CreateModal
                isVisible={createOpen}
                setVisible={setCreateOpen}
                users={users}
            />
            <DeleteModal
                isVisible={deleteOpen}
                setVisible={setDeleteOpen}
                selectedUsers={selectedUsers}
                setSelectedUsers={setSelectedUsers}
            />
            <EditModal
                isVisible={editOpen}
                setVisible={setEditOpen}
                usersId={selectedUser}
            />
            <ViewModal
                isVisible={viewOpen}
                setVisible={setViewOpen}
                usersId={selectedUser}
            />
            <AddKeyModal
                isVisible={addKeyOpen}
                setVisible={setAddKeyOpen}
                usersId={selectedUser}
            />
        </div>
    );
};

export default UsersConfig;